module.exports = __webpack_public_path__ + "kosovo.svg?944545e5362e0e3bedf93cf807dd5352";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/kosovo.svg
// module id = 206
// module chunks = 10